import React, { useEffect, useState } from "react";
import Layout from '../../components/layouts/Layout'
import { BASE_URL, GET_STAFF_MEMBERS_BY_ID_URL } from "../../env";
import {
    getRecords,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
    deleteRecords,
    catchAsync,
} from "../../helper/helper";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
function StaffUserProfile() {
    const loggedInUserDetails = localStorage.getItem("userLoggedInDetails");
    const profileUserDetails = JSON.parse(loggedInUserDetails);
    // console.log("🚀 ~ StaffUserProfile ~ profileUserDetails:", profileUserDetails)
    // console.log("🚀 ~ StaffUserProfile ~ profileUserDetails:", profileUserDetails)
    const storedUserDetails = localStorage.getItem("profileUserDetails");
    const userDetails = JSON.parse(storedUserDetails);
    const [userData, setUserData] = useState([]);

    const apiQuery = {
        staffId: profileUserDetails?._id
    }


    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [filterSearch, setFilterSearch] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [medicationId, setMedicationIdData] = useState({
        medicationId: null,
    });
    const [pbsPlansDetail, setPbsPlansDetail] = useState();
    const [isPbsPlans, setIsPbsPlans] = useState(false);
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

    const [showDeletePbsPlans, setShowDeletePbsPlans] = useState(false);
    const subModalDeletePbsPlans = (delMedicineId) => {
        setMedicationIdData({ medicationId: delMedicineId });
        setShowDeletePbsPlans(!showDeletePbsPlans);
        fetchAllRecords();
    };

    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const actionRecentIncidentsData = data?.data
            setUserData(actionRecentIncidentsData);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_STAFF_MEMBERS_BY_ID_URL, apiQuery);
        
        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    useEffect(() => {
        // console.log("🚀 ~ StaffUserProfile ~ userData:", userData)
    }, [userData]);

    return (
        <>
            <Layout pageTitleText="Staff Profile">
                <div className="mainContent userProfile">
                    <>
                        <div className="userDetailReview">
                            <div className="userImage">
                                <div className="userAvatar">
                                    {!profileUserDetails?.profile_picture_url ? (
                                        <>
                                            <img
                                                src="https://placehold.co/600x400"
                                                alt={userData?.staffMemberName}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <img
                                                src={
                                                    BASE_URL + profileUserDetails?.profile_picture_url
                                                }
                                                alt={userData?.staffMemberName}
                                            />
                                        </>
                                    )}

                                </div>
                            </div>
                            <div className="detailTable">
                                <p className="currentStatus">
                                    {profileUserDetails?.active && (
                                        <>
                                            Current Status: Active{" "}
                                            <span>&nbsp;</span>
                                        </>
                                    )}

                                </p>
                                <header>
                                    <h3>
                                        {userData?.staffMemberName && userData?.staffMemberName}
                                        {" "}
                                        {userData?.lastName && userData?.lastName}
                                    </h3>
                                </header>

                                <div className="userDetailContainer">
                                    <div className="fullDetail">
                                        <p>
                                            <strong>Personal Details</strong>
                                        </p>
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Title</small>
                                                    {userData?.title}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Initials</small>
                                                    {userData?.initials}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Email</small>
                                                    {profileUserDetails?.email}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Primary Contact No.</small>
                                                    {profileUserDetails?.phoneNumber}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Secondary Contact No.</small>
                                                    {userData?.secondaryContactNo}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Date of Birth</small>
                                                    {moment(userData?.stafDob).format("DD/MM/YYYY")}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Ni Numbes</small>
                                                    {userData?.niNumber}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>House / Flat Number</small>
                                                    {userData?.houseFlatNumber}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Address Line 1</small>
                                                    {userData?.addressLine1}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Town</small>
                                                    {userData?.town}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>City</small>
                                                    {userData?.city}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Post Code</small>
                                                    {userData?.postcode}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Driving Status</small>
                                                    {
                                                        userData?.driverFields?.isDriver ? (
                                                            userData?.driverFields?.vehicleType
                                                        ) : (
                                                            "No"
                                                        )
                                                    }
                                                </p>
                                            </div>

                                        </div>
                                        <p>
                                            <strong>Other Details</strong>
                                        </p>
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Contract Hours</small>
                                                    {userData?.contractedHours?.contractedHours}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Contracted Hours Rate</small>
                                                    {userData?.contractedHours?.perHourRate}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Over Night Sleep Rate</small>
                                                    {userData?.contractedHours?.overNightSleepRate}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Enhanced Rate</small>
                                                    {userData?.contractedHours?.enhancedRate}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Training Rate</small>
                                                    {userData?.contractedHours?.trainingRate}
                                                </p>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Overtime Rate</small>
                                                    {userData?.contractedHours?.overtimeRate}
                                                </p>
                                            </div>

                                        </div>
                                        <p>
                                            <strong>Staff Role</strong>
                                        </p>
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6">
                                                <p>
                                                    <small>Staff Roles</small>
                                                    {
                                                        profileUserDetails?.staffRoles?.map((item, index) => (
                                                            <span key={index}>
                                                                {item?.permissionName}<br />
                                                            </span>
                                                        ))
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </Layout>
        </>

    )
}

export default StaffUserProfile